export default "__VITE_ASSET__ANw22Tpe__"